import get from 'lodash/get';
import FactoryAuditState from './state';
import { FactoryAuditTypes } from './types';

const INITIAL_STATE = new FactoryAuditState();

export default function factoryAuditReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    //-------------------------------------------------
    // GET_ITEM_LIST
    case FactoryAuditTypes.GET_ITEM_LIST.LOADING:
      return {
        ...state,
        itemList: {
          ...state.itemList,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.GET_ITEM_LIST.SUCCESS:
      return {
        ...state,
        itemList: {
          loading: false,
          data: {
            ...state.itemList.data,
            [action.key]: action.payload,
          },
          error: null,
        },
      };
    case FactoryAuditTypes.GET_ITEM_LIST.ERROR:
      return {
        ...state,
        itemList: {
          loading: false,
          data: {
            ...state.itemList.data,
            [action.key]: {},
          },
          error: action.payload,
        },
      };
    case FactoryAuditTypes.CREATE_ITEM.LOADING:
      return {
        ...state,
        itemList: {
          ...INITIAL_STATE.itemList,
          loading: true,
        },
      };
    case FactoryAuditTypes.CREATE_ITEM.SUCCESS:
      return {
        ...state,
        itemList: {
          ...INITIAL_STATE.itemList,
          loading: false,
        },
      };
    case FactoryAuditTypes.CREATE_ITEM.ERROR:
      return {
        ...state,
        itemList: {
          ...INITIAL_STATE.itemList,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_ITEM_DETAIL
    case FactoryAuditTypes.GET_ITEM_DETAIL.LOADING: {
      return {
        ...state,
        detailItem: {
          ...state.detailItem,
          loading: true,
          error: null,
        },
      };
    }
    case FactoryAuditTypes.GET_ITEM_DETAIL.SUCCESS: {
      return {
        ...state,
        detailItem: {
          ...INITIAL_STATE.detailItem,
          data: action.payload,
        },
      };
    }
    case FactoryAuditTypes.GET_ITEM_DETAIL.ERROR: {
      return {
        ...state,
        detailItem: {
          ...INITIAL_STATE.detailItem,
          error: action.payload,
        },
      };
    }

    //-------------------------------------------------
    // GET_QUOTE_LIST_ITEM_DETAIL
    case FactoryAuditTypes.GET_QUOTE_LIST_ITEM_DETAIL.LOADING:
      return {
        ...state,
        quoteListItemDetail: {
          ...state.quoteListItemDetail,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.GET_QUOTE_LIST_ITEM_DETAIL.SUCCESS:
      return {
        ...state,
        quoteListItemDetail: {
          ...INITIAL_STATE.quoteListItemDetail,
          data: action.payload,
        },
      };
    case FactoryAuditTypes.GET_QUOTE_LIST_ITEM_DETAIL.ERROR:
      return {
        ...state,
        quoteListItemDetail: {
          ...INITIAL_STATE.quoteListItemDetail,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_QUOTE_ITEM_DETAIL
    case FactoryAuditTypes.GET_QUOTE_ITEM_DETAIL.LOADING:
      return {
        ...state,
        quoteItemDetail: {
          ...state.quoteItemDetail,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.GET_QUOTE_ITEM_DETAIL.SUCCESS:
      return {
        ...state,
        quoteItemDetail: {
          ...INITIAL_STATE.quoteItemDetail,
          data: action.payload,
        },
      };
    case FactoryAuditTypes.GET_QUOTE_ITEM_DETAIL.ERROR:
      return {
        ...state,
        quoteItemDetail: {
          ...INITIAL_STATE.quoteItemDetail,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_REPORT_ITEM_DETAIL
    case FactoryAuditTypes.GET_REPORT_ITEM_DETAIL.LOADING:
      return {
        ...state,
        reportItemDetail: {
          ...state.reportItemDetail,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.GET_REPORT_ITEM_DETAIL.SUCCESS:
      return {
        ...state,
        reportItemDetail: {
          ...INITIAL_STATE.reportItemDetail,
          data: action.payload,
        },
      };
    case FactoryAuditTypes.GET_REPORT_ITEM_DETAIL.ERROR:
      return {
        ...state,
        reportItemDetail: {
          ...INITIAL_STATE.reportItemDetail,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_SERVICE_PROVIDER_LIST
    case FactoryAuditTypes.GET_SERVICE_PROVIDER_LIST.LOADING:
      return {
        ...state,
        serviceProviderList: {
          ...state.serviceProviderList,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.GET_SERVICE_PROVIDER_LIST.SUCCESS:
      return {
        ...state,
        serviceProviderList: {
          ...INITIAL_STATE.serviceProviderList,
          data: action.payload,
        },
      };
    case FactoryAuditTypes.GET_SERVICE_PROVIDER_LIST.ERROR:
      return {
        ...state,
        serviceProviderList: {
          ...INITIAL_STATE.serviceProviderList,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // CREATE_QUOTE_ITEM_DETAIL
    case FactoryAuditTypes.CREATE_QUOTE_ITEM_DETAIL.LOADING:
      return {
        ...state,
        quoteListItemDetail: {
          ...state.quoteListItemDetail,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.CREATE_QUOTE_ITEM_DETAIL.SUCCESS: {
      // const newQuote = action.payload;
      // const newList = state.quoteListItemDetail.push(newQuote);

      return {
        ...state,
        quoteListItemDetail: {
          ...state.quoteListItemDetail,
          loading: false,
          error: null,
        },
      };
    }
    case FactoryAuditTypes.CREATE_QUOTE_ITEM_DETAIL.ERROR:
      return {
        ...state,
        quoteListItemDetail: {
          ...state.quoteListItemDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // CREATE_REPORT_ITEM_DETAIL
    case FactoryAuditTypes.CREATE_REPORT_ITEM_DETAIL.LOADING:
      return {
        ...state,
        reportItemDetail: {
          ...state.reportItemDetail,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.CREATE_REPORT_ITEM_DETAIL.SUCCESS:
      return {
        ...state,
        reportItemDetail: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };
    case FactoryAuditTypes.CREATE_REPORT_ITEM_DETAIL.ERROR:
      return {
        ...state,
        reportItemDetail: {
          ...state.reportItemDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_INVOICE_ITEM_DETAIL
    case FactoryAuditTypes.GET_INVOICE_ITEM_DETAIL.LOADING:
      return {
        ...state,
        invoiceItemDetail: {
          ...state.invoiceItemDetail,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.GET_INVOICE_ITEM_DETAIL.SUCCESS:
      return {
        ...state,
        invoiceItemDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case FactoryAuditTypes.GET_INVOICE_ITEM_DETAIL.ERROR:
      return {
        ...state,
        invoiceItemDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_INVOICE_LIST_ITEM_DETAIL
    case FactoryAuditTypes.GET_INVOICE_LIST_ITEM_DETAIL.LOADING:
      return {
        ...state,
        invoiceListItemDetail: {
          ...state.invoiceListItemDetail,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.GET_INVOICE_LIST_ITEM_DETAIL.SUCCESS:
      return {
        ...state,
        invoiceListItemDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case FactoryAuditTypes.GET_INVOICE_LIST_ITEM_DETAIL.ERROR:
      return {
        ...state,
        invoiceListItemDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // CREATE_INVOICE_ITEM_DETAIL
    case FactoryAuditTypes.CREATE_INVOICE_ITEM_DETAIL.LOADING:
      return {
        ...state,
        invoiceListItemDetail: {
          ...state.invoiceListItemDetail,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.CREATE_INVOICE_ITEM_DETAIL.SUCCESS: {
      // const newInvoiceList = action.payload;
      // const newList = [...newInvoiceList, ...get(state, 'invoiceListItemDetail.data.list', [])];
      return {
        ...state,
        invoiceListItemDetail: {
          loading: false,
          data: action.payload, // { ...state.invoiceListItemDetail.data, list: newList },
          error: null,
        },
      };
    }
    case FactoryAuditTypes.CREATE_INVOICE_ITEM_DETAIL.ERROR:
      return {
        ...state,
        invoiceListItemDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // UPDATE_INVOICE_ITEM_DETAIL
    case FactoryAuditTypes.UPDATE_INVOICE_ITEM_DETAIL.LOADING:
      return {
        ...state,
        invoiceListItemDetail: {
          ...state.invoiceListItemDetail,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.UPDATE_INVOICE_ITEM_DETAIL.SUCCESS: {
      return {
        ...state,
        invoiceListItemDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    }
    case FactoryAuditTypes.UPDATE_INVOICE_ITEM_DETAIL.ERROR:
      return {
        ...state,
        invoiceListItemDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DELETE_INVOICE_ITEM_DETAIL
    case FactoryAuditTypes.DELETE_INVOICE_ITEM_DETAIL.LOADING:
      return {
        ...state,
        invoiceListItemDetail: {
          ...state.invoiceListItemDetail,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.DELETE_INVOICE_ITEM_DETAIL.SUCCESS: {
      const removedInvoiceId = Number(action.payload);
      const newList = get(state, 'invoiceListItemDetail.data.list', []).filter(
        (item) => item.id !== removedInvoiceId
      );
      return {
        ...state,
        invoiceListItemDetail: {
          loading: false,
          data: {
            ...state.invoiceListItemDetail.data,
            list: newList,
          },
          error: null,
        },
      };
    }
    case FactoryAuditTypes.DELETE_INVOICE_ITEM_DETAIL.ERROR:
      return {
        ...state,
        invoiceListItemDetail: {
          ...state.invoiceListItemDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // UPDATE_ITEM_DETAIL
    case FactoryAuditTypes.UPDATE_ITEM_DETAIL.LOADING: {
      return {
        ...state,
        detailItem: {
          ...state.detailItem,
          loading: true,
          error: null,
        },
      };
    }
    case FactoryAuditTypes.UPDATE_ITEM_DETAIL.SUCCESS: {
      return {
        ...state,
        detailItem: {
          ...INITIAL_STATE.detailItem,
          data: action.payload,
        },
      };
    }
    case FactoryAuditTypes.UPDATE_ITEM_DETAIL.ERROR: {
      return {
        ...state,
        detailItem: {
          ...state.detailItem,
          error: action.payload,
        },
      };
    }

    //-------------------------------------------------
    // UPDATE_QUOTE_ITEM_DETAIL
    case FactoryAuditTypes.UPDATE_QUOTE_ITEM_DETAIL.LOADING:
      return {
        ...state,
        quoteListItemDetail: {
          ...state.quoteListItemDetail,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.UPDATE_QUOTE_ITEM_DETAIL.SUCCESS: {
      // const updatedQuote = action.payload;
      // const newList = state.quoteListItemDetail.map(
      //   (item) => [updatedQuote].find((u) => u.id === item.id) || item
      // );

      return {
        ...state,
        quoteListItemDetail: {
          ...state.quoteListItemDetail,
          loading: false,
          error: null,
        },
      };
    }
    case FactoryAuditTypes.UPDATE_QUOTE_ITEM_DETAIL.ERROR:
      return {
        ...state,
        quoteListItemDetail: {
          ...state.quoteListItemDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DOWNLOAD_QUOTE_ATTACHMENT_ITEM_DETAIL
    case FactoryAuditTypes.DOWNLOAD_QUOTE_ATTACHMENT_ITEM_DETAIL.LOADING:
      return {
        ...state,
        quoteAttachmentItemDetail: {
          ...INITIAL_STATE.quoteAttachmentItemDetail,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.DOWNLOAD_QUOTE_ATTACHMENT_ITEM_DETAIL.SUCCESS:
      return {
        ...state,
        quoteAttachmentItemDetail: {
          ...INITIAL_STATE.quoteAttachmentItemDetail,
          data: action.payload,
        },
      };
    case FactoryAuditTypes.DOWNLOAD_QUOTE_ATTACHMENT_ITEM_DETAIL.ERROR:
      return {
        ...state,
        quoteAttachmentItemDetail: {
          ...INITIAL_STATE.quoteAttachmentItemDetail,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DOWNLOAD_REPORT_ATTACHMENT_ITEM_DETAIL
    case FactoryAuditTypes.DOWNLOAD_REPORT_ATTACHMENT_ITEM_DETAIL.LOADING:
      return {
        ...state,
        reportAttachmentItemDetail: {
          ...INITIAL_STATE.reportAttachmentItemDetail,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.DOWNLOAD_REPORT_ATTACHMENT_ITEM_DETAIL.SUCCESS:
      return {
        ...state,
        reportAttachmentItemDetail: {
          ...INITIAL_STATE.reportAttachmentItemDetail,
          data: action.payload,
        },
      };
    case FactoryAuditTypes.DOWNLOAD_REPORT_ATTACHMENT_ITEM_DETAIL.ERROR:
      return {
        ...state,
        reportAttachmentItemDetail: {
          ...INITIAL_STATE.reportAttachmentItemDetail,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DOWNLOAD_INVOICE_LIST_ITEM_DETAIL
    case FactoryAuditTypes.DOWNLOAD_INVOICE_LIST_ITEM_DETAIL.LOADING:
      return {
        ...state,
        invoiceDownloadedListItemDetail: {
          loading: true,
          data: {},
          error: null,
        },
      };
    case FactoryAuditTypes.DOWNLOAD_INVOICE_LIST_ITEM_DETAIL.SUCCESS:
      return {
        ...state,
        invoiceDownloadedListItemDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case FactoryAuditTypes.DOWNLOAD_INVOICE_LIST_ITEM_DETAIL.ERROR:
      return {
        ...state,
        invoiceDownloadedListItemDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    case FactoryAuditTypes.DOWNLOAD_INVOICE_LIST_ITEM_DETAIL.RESET:
      return {
        ...state,
        invoiceDownloadedListItemDetail: INITIAL_STATE.invoiceDownloadedListItemDetail,
      };

    //-------------------------------------------------
    //-------------------------------------------------
    // GET_PAYER_LIST
    case FactoryAuditTypes.GET_PAYER_LIST.LOADING:
      return {
        ...state,
        payerList: {
          ...INITIAL_STATE.payerList,
          loading: true,
          error: null,
        },
      };
    case FactoryAuditTypes.GET_PAYER_LIST.SUCCESS:
      return {
        ...state,
        payerList: {
          ...INITIAL_STATE.payerList,
          data: action.payload,
        },
      };
    case FactoryAuditTypes.GET_PAYER_LIST.ERROR:
      return {
        ...state,
        payerList: {
          ...INITIAL_STATE.payerList,
          error: action.payload,
        },
      };
    //-------------------------------------------------
    default:
      return state;
  }
}
